import { useState, type FormEvent } from 'react';
import { Button, FormField, Input } from '@/shared/components';

/** Zwei-Faktor einrichten, Schritt 1: Passwort bestätigen; der QR-Code kommt erst danach. */
export function TwoFactorBeginCard({
  failure,
  onBegin,
}: {
  failure: string | null;
  onBegin: (password: string) => Promise<void>;
}) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!password) return;
    setBusy(true);
    try {
      await onBegin(password);
      setPassword('');
    } finally {
      setBusy(false);
    }
  };
  return (
    <form
      onSubmit={(event) => void submit(event)}
      className="border-hairline rounded-tile flex flex-col gap-3 border bg-white p-5"
    >
      <span className="text-ink-soft font-mono text-[11px] font-semibold uppercase tracking-[0.14em]">
        Schritt 1 · Passwort bestätigen
      </span>
      <b className="font-serif text-xl">Authenticator-App verbinden</b>
      <p className="text-ink-soft text-sm">
        Gib dein aktuelles Passwort ein. Der QR-Code erscheint erst nach der Prüfung.
      </p>
      {failure && (
        <p
          role="alert"
          className="bg-sealwax-tint text-sealwax rounded-control p-3 text-sm font-semibold"
        >
          {failure}
        </p>
      )}
      <div className="max-w-md">
        <FormField label="Aktuelles Passwort" required>
          <Input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </FormField>
      </div>
      <Button
        type="submit"
        variant="brand"
        size="lg"
        className="self-start"
        loading={busy}
        disabled={!password}
      >
        Einrichtung starten
      </Button>
    </form>
  );
}
